import { Component, Input } from '@angular/core';
import { AvatarBackgroundSizes, AvatarShapes } from 'mojo-avatar';
import { MojoTaskListItemComponent, Task } from 'mojo-tasks';
import { hasAnonymization } from '@collections/users';

@Component({
  selector: 'mojo-task-list-item',
  templateUrl: './task-list-item.component.html',
  styleUrls: ['./task-list-item.component.scss'],
})
export class TaskListItemComponent extends MojoTaskListItemComponent {
  @Input() task: Task;
  @Input() sideDrawerConfiguration;
  @Input() fromDashboard = false;

  avatarPhotoShape = AvatarShapes.circle;
  avatarBackground = AvatarBackgroundSizes.cover;
  hasAnonymization$ = this.store.select(hasAnonymization);
  today = new Date(new Date().setUTCHours(0, 0, 0, 0));

  readonly maxLength = 20;

  navigateAssign(entityType, id) {
    switch (entityType) {
      case 'CANDIDATE':
        this.router.navigate(['candidates', id, 'details']);
        break;
      case 'JOB':
        this.router.navigate(['/jobs', 'job', id]);
        break;
      case 'TALENT_POOL':
        this.router.navigate(['/talent-pools', id]);
        break;
    }
  }

  getEntityName(task: Task) {
    if (task?.entityName?.length > this.maxLength) {
      return this.task.entityName.substring(0, this.maxLength) + '...';
    }

    return task.entityName;
  }

  isValidEntityName(task: Task) {
    return !task.entityName.includes('null');
  }

  getDate(date: Date) {
    const dateFormated = new Date(date);

    return new Date(dateFormated.getTime() + Math.abs(dateFormated.getTimezoneOffset() * 60000));
  }
}
